import React from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';
import MediaViewer, { MediaViewerProps } from './media-viewer';
import Modal from '../../shared/modal';

type Props = {
  visible: boolean,
} & MediaViewerProps;

export default class ModalMediaViewer extends React.Component<Props> {
  handleHide = () => {
    this.props.onClose?.();
  };

  render() {
    if (!this.props.initialItem) {
      return null;
    }
    // @ts-ignore
    const { styles } = ModalMediaViewer;

    /* eslint-disable no-use-before-define */
    const { visible, ...props } = this.props;
    /* eslint-enable no-use-before-define */

    return (
      <Modal
        show={visible}
        onHide={this.handleHide}
        customModalStyles={{ zIndex: '675' }}
      >
        <div className={cx('modal-content', styles.container)}>
          <MediaViewer {...props} />
        </div>
      </Modal>
    );
  }
}

const styles = cssInJS({
  container: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    minHeight: 300,
    // @ts-ignore
    '@phone': {
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
    },
  },
});
// @ts-ignore
ModalMediaViewer.styles = styles;
